import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const LOGS_URL = getBaseUrl('/logs/');

export async function getLogs(file) {
    return await appRequest.doGetRequest(`${LOGS_URL}${file}`);
}

export async function clearLog(file) {
    return await appRequest.doDeleteRequest(`${LOGS_URL}${file}`);
}

export async function clearAllLogs() {
    return await appRequest.doDeleteRequest(LOGS_URL);
}
